/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamHandshakeCanaryResponse } from './oralExamHandshakeCanaryResponse';

export type GenericApiResponseOralExamHandshakeCanaryResponseData = OralExamHandshakeCanaryResponse | null;
